import Title from '../Title.jsx';
import { useTranslation } from 'react-i18next';

const LegalNotice = () => {
  const { t } = useTranslation();

  const sections =
    t('legal_notice.legal_data.sections', { returnObjects: true }) || [];

  return (
    <div className='flex flex-col p-6 md:p-12 gap-6 md:gap-12 text-center max-w-[1600px] mx-auto w-full break-words'>
      <Title> {t('legal_notice.legal_data.title')} </Title>
      <p className='text-lg lg:text-xl font-light text-gray-500'>
        {t('legal_notice.legal_data.legal_subtitle')}
        <span className='font-medium text-primary-red'>
          {' '}
          Quantessence{' '}
        </span>{' '}
        {t('legal_notice.legal_data.legal_common')}{' '}
        {t('legal_notice.legal_data.legal_date')}
      </p>
      <div className='w-full text-primary-blue text-justify flex flex-col gap-6 md:gap-12'>
        {sections.map((section, index) => (
          <div key={index}>
            <p className='text-xl lg:text-2xl font-medium'>{section.heading}</p>
            {section.paragraphs.map((paragraph, pIndex) => (
              <p
                key={pIndex}
                className='py-2 text-lg lg:text-xl font-light'
                dangerouslySetInnerHTML={{ __html: paragraph }}
              ></p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LegalNotice;
